export default {
  DEFAULT:
    'open sans,-apple-system,Helvetica Neue,Helvetica,Open Sans,Arial,PingFang SC,PingFang TC,Hiragino Sans GB,Microsoft Yahei,Microsoft Jhenghei,sans-serif',
}
